interface AnalogClockProps {
  hours: number;
  minutes: number;
  seconds: number;
  size?: number;
}

const AnalogClock: React.FC<AnalogClockProps> = ({ hours, minutes, seconds, size = 32 }) => {
  const cx = size / 2;
  const cy = size / 2;
  const r = size / 2 - 1.5;

  const secondAngle = (seconds / 60) * 360;
  const minuteAngle = ((minutes + seconds / 60) / 60) * 360;
  const hourAngle = (((hours % 12) + minutes / 60) / 12) * 360;

  const rot = (angle: number) => `rotate(${angle}, ${cx}, ${cy})`;

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      <circle cx={cx} cy={cy} r={r} fill="none" stroke="currentColor" strokeWidth="1.5" />

      {Array.from({ length: 12 }, (_, i) => {
        const angle = (i / 12) * Math.PI * 2 - Math.PI / 2;
        const isMain = i % 3 === 0;
        const inner = r - (isMain ? 4 : 2.5);
        const outer = r - 0.75;
        return (
          <line
            key={i}
            x1={cx + Math.cos(angle) * inner}
            y1={cy + Math.sin(angle) * inner}
            x2={cx + Math.cos(angle) * outer}
            y2={cy + Math.sin(angle) * outer}
            stroke="currentColor"
            strokeWidth={isMain ? 1.5 : 0.75}
            strokeLinecap="round"
          />
        );
      })}

      <line
        x1={cx} y1={cy + 3} x2={cx} y2={cy - r * 0.5}
        stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"
        transform={rot(hourAngle)}
      />
      <line
        x1={cx} y1={cy + 3} x2={cx} y2={cy - r * 0.75}
        stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
        transform={rot(minuteAngle)}
      />
      <line
        x1={cx} y1={cy + 4} x2={cx} y2={cy - r * 0.85}
        stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeOpacity="0.6"
        transform={rot(secondAngle)}
      />

      <circle cx={cx} cy={cy} r="2" fill="currentColor" />
    </svg>
  );
};

export default AnalogClock;
